import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Services from "@/pages/services/page";
import About from "@/pages/about/page";
import Company from "@/pages/company/page";
import Cases from "@/pages/cases/page";
import Faq from "@/pages/faq/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <Services /> },
  { path: "/about", element: <About /> },
  { path: "/company", element: <Company /> },
  { path: "/cases", element: <Cases /> },
  { path: "/faq", element: <Faq /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;